import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { App } from "./App";
import { ThemeProvider } from "./theme/ThemeProvider";
import { initFromStoredConsent } from "./lib/analytics";
import "./i18n";
import "./styles/tokens.css";
import "./styles.css";
import "./styles/print.css";

initFromStoredConsent();

const root = document.getElementById("root")!;
const app = (
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

if (root.dataset.prerendered) {
  hydrateRoot(root, app);
} else {
  createRoot(root).render(app);
}
